import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuthContext } from '../../hooks/useAuthContext';
import { apiFetch } from '../../utils/api';
import { normalizeTranslation } from '../../utils/translationUtils';
import { isKnownBlogSection, normalizeBlogSection } from '../../components/BlogPostEditor/blogSectionTypes';
import BlogPostEditor from '../../components/BlogPostEditor/BlogPostEditor';
import Spinner from '../../components/Spinner/Spinner';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import BackLink from '../../components/BackLink/BackLink';
import '../AdminItemPage/AdminItemPage.css';

const NEW_POST_ID = 'new';

const normalizePost = (raw) => ({
  title: normalizeTranslation(raw.title),
  image: raw.image ?? '',
  imageFileId: raw.imageFileId ?? null,
  status: raw.status ?? 'draft',
  sections: (raw.sections ?? []).filter(isKnownBlogSection).map(normalizeBlogSection),
});

const AdminBlogPostPage = () => {
  const { id } = useParams();
  const isNew = id === NEW_POST_ID;
  const { user } = useAuthContext();
  const navigate = useNavigate();
  const [loaded, setLoaded] = useState({ id: null, post: null });
  const post = loaded.post;

  useEffect(() => {
    if (isNew) return;
    const load = async () => {
      const res = await apiFetch(`/api/admin/blog/${id}`, {
        headers: { Authorization: `Bearer ${user.token}` },
      });
      setLoaded({ id, post: res.ok ? normalizePost(await res.json()) : null });
    };
    load();
  }, [id, isNew, user.token]);

  if (!isNew && loaded.id !== id) return <Spinner />;
  if (!isNew && !post) return <div>Post not found.</div>;

  const title = isNew ? 'New Post' : (post.title.en || 'Untitled');

  return (
    <div className="admin-item-page">
      <Breadcrumb items={[
        { label: 'Blog Posts', to: '/admin/blog' },
        { label: title },
      ]} />

      <BackLink to="/admin/blog" label="Back to blog posts" />

      <h2 className="admin-item-title">{title}</h2>

      <div className="admin-item-editor-wrap">
        <BlogPostEditor
          key={id}
          postId={isNew ? null : id}
          initialPost={isNew ? null : post}
          onCreated={(createdId) => navigate(`/admin/blog/${createdId}`, { replace: true })}
        />
      </div>
    </div>
  );
};

export default AdminBlogPostPage;
